const ScrollTop = () => {
	return (
		<a className="scroll-to-top rounded" href="#root">
			<i className="fas fa-angle-up"></i>
		</a>
	);
};

export default ScrollTop;
